<template>
    <Page :header="header[lang].title" type="gray">
        <template v-slot:body>
            <div class="w-full flex flex-column xl:flex-row lg:flex-row md:flex-row
                gap-3 xl:gap-4 lg:gap-3 md:gap-3">
                <div class="flex flex-row relative gap-3 xl:gap-4 lg:gap-3 md:gap-3 w-full">
                    <div @click="goTo(products[0].path)"
                        class="w-full flex flex-column flex-1 surface-0 p-0
                        border-round-2xl xl:border-round-2xl lg:border-round-2xl md:border-round-xl
                        text-left cursor-pointer relative" 
                        :style="(screenSize === 'xl') ? 'padding-bottom:20%;padding-bottom:calc(20% - 0.5rem)!important' : (screenSize === 'lg') ? 'padding-bottom:30%;padding-bottom:calc(30% - 0.5rem)!important' : 'padding-bottom:50%;padding-bottom:calc(50% - 0.5rem)!important'">
                        <div class="absolute w-full top-0 bottom-0 right-0 left-0">
                            <div class="absolute w-full top-0 left-0 pt-3 pl-3">
                                <span class="flex text-600 mb-2 text-md font-medium pr-4">
                                    {{ products[0].name[lang] }}
                                </span>
                                <span v-if="!isUserInGroup('partner')" class="flex text-500 mb-2 text-xs font-medium pr-4">
                                    {{ products[0].description[lang] }}
                                </span>
                            </div>
                            <div class="absolute w-full bottom-0 left-0 pb-3 pl-3">
                                <span v-if="isUserInGroup('partner') && prods && prods.partner" class="flex text-700 text-4xl font-medium white-space-nowrap
                                    mt-6 xl:mt-10 lg:mt-10 md:mt-8">
                                    {{ get_format_amount(prods.partner.balance, 'usd') }}
                                </span>
                            </div>
                            <div class="absolute bottom-0 right-0 pb-3 pr-3">
                                <Button v-if="!isUserInGroup('partner')" icon="pi pi-plus" iconPos="right" class="" rounded />
                            </div>
                        </div>
                    </div>
                    <div @click="goTo(products[1].path)"
                        class="w-full flex flex-column flex-1 surface-0 p-0
                        border-round-2xl xl:border-round-2xl lg:border-round-2xl md:border-round-xl
                        text-left cursor-pointer relative" style="padding-bottom:50%;padding-bottom:calc(50% - 0.5rem)!important">
                        <div class="absolute w-full top-0 bottom-0 right-0 left-0">
                            <div class="absolute w-full top-0 left-0 pt-3 pl-3">
                                <span class="flex text-600 mb-2 text-md font-medium pr-4">
                                    {{ products[1].name[lang] }}
                                </span>
                                <span v-if="!isUserInGroup('merchant')" class="flex text-500 mb-2 text-xs font-medium pr-4">
                                    {{ products[1].description[lang] }}
                                </span>
                            </div>
                            <div class="absolute w-full bottom-0 left-0 pb-3 pl-3">
                                <span v-if="isUserInGroup('merchant') && prods && prods.merchant" class="flex text-700 text-4xl font-medium white-space-nowrap
                                    mt-6 xl:mt-10 lg:mt-10 md:mt-8">
                                    {{ get_format_amount(prods.merchant.balance, 'usd') }}
                                </span>
                            </div>
                            <div class="absolute bottom-0 right-0 pb-3 pr-3">
                                <Button v-if="!isUserInGroup('merchant')" icon="pi pi-plus" iconPos="right" class="" rounded />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex flex-row gap-3 xl:gap-4 lg:gap-3 md:gap-3 w-full">
                    <div @click="goTo(products[2].path)"
                        class="w-full flex flex-column flex-1 surface-0 p-0
                        border-round-2xl xl:border-round-2xl lg:border-round-2xl md:border-round-xl
                        text-left cursor-pointer relative" style="padding-bottom:50%;padding-bottom:calc(50% - 0.5rem)!important">
                        <div class="absolute w-full top-0 bottom-0 right-0 left-0">
                            <div class="absolute w-full top-0 left-0 pt-3 pl-3">
                                <span class="flex text-600 mb-2 text-md font-medium pr-4">
                                    {{ products[2].name[lang] }}
                                </span>
                                <span v-if="!isUserInGroup('vcard')" class="flex text-500 mb-2 text-xs font-medium pr-4">
                                    {{ products[2].description[lang] }}
                                </span>
                            </div>
                            <div class="absolute w-full bottom-0 left-0 pb-3 pl-3">
                                <span v-if="isUserInGroup('vcard') && prods && prods.vcard" class="flex text-700 text-4xl font-medium white-space-nowrap
                                    mt-6 xl:mt-10 lg:mt-10 md:mt-8">
                                    {{ get_format_amount(prods.vcard.balance, 'usd') }}
                                </span>
                            </div>
                            <div class="absolute bottom-0 right-0 pb-3 pr-3">
                                <Button v-if="!isUserInGroup('vcard')" icon="pi pi-plus" iconPos="right" class="" rounded />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex flex-row gap-3 xl:gap-4 lg:gap-3 md:gap-3 w-full">
                    <div v-if="isUserInGroup('admin') && products[4]" @click="goTo(products[4].path)"
                        class="w-full flex flex-column flex-1 surface-0 p-0
                        border-round-2xl xl:border-round-2xl lg:border-round-2xl md:border-round-xl
                        text-left cursor-pointer relative" style="padding-bottom:50%;padding-bottom:calc(50% - 0.5rem)!important">
                        <div class="absolute w-full top-0 bottom-0 right-0 left-0">
                            <div class="absolute w-full top-0 left-0 pt-3 pl-3">
                                <span class="flex text-600 mb-2 text-md font-medium pr-4">
                                    {{ products[4].name[lang] }}
                                </span>
                            </div>
                            <div class="absolute w-full bottom-0 left-0 pb-3 pl-3">
                                
                            </div>
                            <div class="absolute bottom-0 right-0 pb-3 pr-3">
                                <Button v-if="!isUserInGroup('admin')" icon="pi pi-plus" iconPos="right" class="" rounded />
                            </div>
                        </div>
                    </div>
                    <div v-if="(isUserInGroup('admin') || isUserInGroup('manager')) && products[5]" @click="goTo(products[5].path)"
                        class="w-full flex flex-column flex-1 surface-0 p-0
                        border-round-2xl xl:border-round-2xl lg:border-round-2xl md:border-round-xl
                        text-left cursor-pointer relative" style="padding-bottom:50%;padding-bottom:calc(50% - 0.5rem)!important">
                        <div class="absolute w-full top-0 bottom-0 right-0 left-0">
                            <div class="absolute w-full top-0 left-0 pt-3 pl-3">
                                <span class="flex text-600 mb-2 text-md font-medium pr-4">
                                    {{ products[5].name[lang] }}
                                </span>
                            </div>
                            <div class="absolute w-full bottom-0 left-0 pb-3 pl-3">
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </Page>
</template>

<script>
import Page     from '@/components/sides/Page.vue' 
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import { mapActions } from 'vuex'

export default {
    name: 'Products',
    data() {
        return {
            header: {
                en: { title: 'My products' },
                ru: { title: 'Мои продукты' },
            },
            products: [
                { 
                    id: 1, 
                    name: {
                        en: 'Partners program',
                        ru: 'Партнерская программа'
                    },
                    description: {
                        en: 'Get income from referrals',
                        ru: 'Получайте доход от рекомендаций'
                    },
                    path: '/personal/partner/' 
                },
                { 
                    id: 2, 
                    name: {
                        en: 'Currency trading',
                        ru: 'Торговля валютой'
                    },
                    description: {
                        en: 'Earn on the difference in exchange rates',
                        ru: 'Зарабатывайте на разнице курсов валют'
                    },
                    path: '/merchant/' 
                },
                { 
                    id: 3, 
                    name: {
                        en: 'Virtual cards',
                        ru: 'Виртуальные карты'
                    },
                    description: {
                        en: 'Create a virtual card for online shopping',
                        ru: 'Создайте виртуальную карту для покупок в интернете'
                    },
                    path: '/personal/vcards/' 
                },
                { 
                    id: 4, 
                    name: {
                        en: 'Accept payment',
                        ru: 'Прием оплат'
                    },
                    description: {
                        en: 'Accept payment in currency',
                        ru: 'Принимайте оплату в валюте'
                    },
                    path: '/personal/bills/' 
                },
                { 
                    id: 4, 
                    name: {
                        en: 'Esim',
                        ru: 'Esim'
                    },
                    description: {
                        en: 'Emission and management of esim',
                        ru: 'Выпуск и управление esim'
                    },
                    path: '/personal/esim/' 
                },
                { 
                    id: 5, 
                    name: {
                        en: 'Admin',
                        ru: 'Админ'
                    },
                    description: {
                        en: '',
                        ru: ''
                    },
                    path: '/admin/' 
                },
            ],
            content: {
                ru: {
                    error: 'Ошибка',
                    error_text: 'Ошибка получения данных'
                },
                en: {
                    error: 'Error',
                    error_text: 'Error getting data'
                }
            },
            prods: [],
            loading: false
        };
    },
    components: {
        Page
    },
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        isDarkTheme() { return this.$store.getters.StateDarkTheme },
        screenSize() { return this.$store.getters.StateScreenSize },
    },
    methods: {
        isUserInGroup (type) { return this.helper.isUserInGroup(type, this.$store.getters.StateGroups)},
        goTo(path) {
            this.$router.push({ path });
        },
        showMess(severity, summary, detail) {
            this.$toast.add({ severity: severity, summary: summary, detail: detail, life: 3000 });
        },
        ...mapActions(['SetHeaderTitle', 'SetHeaderBtnLeftFirst', 'SetHeaderBtnLeftSecond', 'SetHeaderBtnRightFirst', 'SetHeaderBtnRightSecond']),
        get_format_amount(value, currency) {
            return this.helper.format_amount(value, currency, 0)
        },
    },
    beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    mounted() {
        this.helper.SetTgAppHeadColor('white', this.isDarkTheme)
        this.helper.SetTgAppBackButton(false)

        try {
            this.SetHeaderTitle(this.header[this.lang].title)
            this.SetHeaderBtnLeftFirst({
                type: 'link',
                link: null,
                icon: 'pi pi-comments',
                class: 'text-xs opacity-0',
                rounded: true,
                severity: 'secondary',
                visible: true,
            })
            this.SetHeaderBtnLeftSecond({})
            this.SetHeaderBtnRightFirst({
                type: 'link',
                link: '/support/',
                icon: 'pi pi-comments',
                class: 'text-xs',
                rounded: true,
                severity: 'secondary',
                visible: true,
            })
            this.SetHeaderBtnRightSecond({})
        } catch (error) {
            console.error('Error setting header:', error)
        }
    }
};
</script>